let hour = 0, minute = 0, second = 0;

export function setChronometer() {
  if (second == 60) {
      minute++;
      second = 0;
  }

  if (minute == 60) {
      hour++;
      minute = 0;
      second = 0;
  }

  const hours = hour.toString().padStart(2, '0'),
    minutes = minute.toString().padStart(2, '0'),
    seconds = second.toString().padStart(2, '0');

  second++;
  return `${hours} : ${minutes} : ${seconds}`
}

export function resetChronometer() {
  hour = 0; 
  minute = 0;
  second = 0;
  return '00 : 00 : 00';
}